import { render, staticRenderFns } from "./bac-members.vue?vue&type=template&id=0fe44445&"
import script from "./bac-members.vue?vue&type=script&lang=js&"
export * from "./bac-members.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports